import { App } from '../AppManager';

interface SitemapGeneratorOptions {
  appData: App;
  customDomain?: string;
}

export const generateSitemap = ({ appData, customDomain }: SitemapGeneratorOptions): string => {
  // Get the primary domain (custom domain or Firebase domain)
  const primaryDomain = customDomain || `${appData.id}.web.app`;
  const baseUrl = `https://${primaryDomain}`;
  
  // Current date in ISO format for lastmod
  const currentDate = new Date().toISOString().split('T')[0];
  
  // Common pages for a restaurant ordering app
  const pages = [
    {
      url: '/',
      changefreq: 'daily',
      priority: '1.0',
      lastmod: currentDate
    },
    {
      url: '/menu',
      changefreq: 'daily',
      priority: '0.9',
      lastmod: currentDate
    },
    {
      url: '/cart',
      changefreq: 'never',
      priority: '0.3',
      lastmod: currentDate
    },
    {
      url: '/orders',
      changefreq: 'never',
      priority: '0.3',
      lastmod: currentDate
    },
    {
      url: '/contact',
      changefreq: 'monthly',
      priority: '0.7',
      lastmod: currentDate
    },
    {
      url: '/about',
      changefreq: 'monthly',
      priority: '0.6',
      lastmod: currentDate
    }
  ];

  // Generate XML sitemap
  const sitemapContent = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${pages.map(page => `  <url>
    <loc>${baseUrl}${page.url}</loc>
    <lastmod>${page.lastmod}</lastmod>
    <changefreq>${page.changefreq}</changefreq>
    <priority>${page.priority}</priority>
  </url>`).join('\n')}
</urlset>`;

  return sitemapContent;
};

export const generateSitemapFile = (options: SitemapGeneratorOptions): { content: string; filename: string } => {
  const content = generateSitemap(options);
  const filename = 'sitemap.xml';
  
  return {
    content,
    filename
  };
};